import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';

import { LoginLoc } from '../loc/login';
import { loc } from '../lib/loc';

import NotFound from '../interface/NotFound';

import Login from './LoginScreens/Login';
import Recovery from './LoginScreens/Recovery';
import { useStores } from '../hooks/use-stores';

const LoginScreen = ({ errorMessage, backUrl }) => {
    const { HeaderStore } = useStores();

    useEffect(() => {
        HeaderStore.setTitle('Aвторизация');

        return () => {
            HeaderStore.setTitle('');
        };
    }, [HeaderStore]);

    return (
        <Switch>
            <Route path="/login/recovery" component={Recovery} />
            <Route exact path="/login" render={() => <Login errorMessage={errorMessage || null} backUrl={backUrl} />} />
            <Route
                render={() => (
                    <NotFound
                        button={{
                            to: '/login/',
                            title: loc(LoginLoc.generalLogin),
                        }}
                    />
                )}
            />
        </Switch>
    );
};

export default LoginScreen;
